import { Controller } from "@hotwired/stimulus";

// Brouillon GO4SIA des commentaires du chef d'établissement : demande le
// brouillon au serveur et remplit les champs, sans rien enregistrer. Le chef
// relit, corrige, puis enregistre avec le bouton du formulaire.
export default class extends Controller {
  static targets = ["field", "button", "status"];
  static values = { url: String, working: String, done: String };

  async draft() {
    this.buttonTarget.disabled = true;
    this.statusTarget.textContent = this.workingValue;
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
      });
      const body = await response.json();
      if (!response.ok || !body.comments) {
        this.statusTarget.textContent = body.error || "";
        return;
      }
      this.fieldTargets.forEach((field) => {
        const text = body.comments[field.dataset.key];
        if (text) field.value = text;
      });
      this.statusTarget.textContent = this.doneValue;
    } catch (_error) {
      this.statusTarget.textContent = "";
    } finally {
      this.buttonTarget.disabled = false;
    }
  }
}
